import { getMm } from "../theme/modernMaterialEnterprise";
/** Shared size/style for language + theme toggles on public auth pages. */

export const AUTH_TOGGLE_BUTTON_PX = 44;
export const AUTH_TOGGLE_ICON_PX = 24;

export function authToggleButtonShellSx(isDarkMode) {
  return {
    width: AUTH_TOGGLE_BUTTON_PX,
    height: AUTH_TOGGLE_BUTTON_PX,
    minWidth: AUTH_TOGGLE_BUTTON_PX,
    minHeight: AUTH_TOGGLE_BUTTON_PX,
    borderRadius: "8px",
    backgroundColor: getMm(isDarkMode).surfaceLowest,
    border: `1px solid ${getMm(isDarkMode).outlineVariant}`,
    boxShadow: "none",
    p: 0,
    "&:hover": {
      backgroundColor: getMm(isDarkMode).surfaceLow,
    },
    transition: "background-color 0.2s ease",
  };
}
